var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Text, TextContainer } from './subcomponents';
var RewardsLegalInfo = function (_a) {
    var description = _a.description;
    return (_jsx(TextContainer, { children: _jsx(Text, __assign({ "data-cy": "legal-info" }, { children: description })) }));
};
export default RewardsLegalInfo;
